import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  IInfoPlanDevice,
  IClientInfo,
} from "../../provider/thaniacel.provider.interfaces";

interface IProps {
  children: ReactNode;
}

interface IAuthAgent {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgent | null;
  client: IClientInfo | null;
  infoPlanDevice: IInfoPlanDevice | null;
  infoPayment: any;
  setInfoPayment: Dispatch<SetStateAction<any>>;
  setStep: Dispatch<SetStateAction<number>>;
  setUser: Dispatch<SetStateAction<IAuthAgent | null>>;
  setInfoPlanDevice: Dispatch<SetStateAction<IInfoPlanDevice | null>>;
  setClient: Dispatch<SetStateAction<IClientInfo | null>>;
  handleInitialState: () => void;
};

export const CreateNewsThaniacelContext = React.createContext<IContext>(
  {} as IContext,
);
export const useCreateNewsThaniacelContext = () =>
  useContext<IContext>(CreateNewsThaniacelContext);

const CreateNewsThaniacelProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgent | null>(null);
  const [infoPlanDevice, setInfoPlanDevice] = useState<IInfoPlanDevice | null>(
    null,
  );
  const [client, setClient] = useState<IClientInfo | null>(null);
  const [infoPayment, setInfoPayment] = useState<any>(null);
  const handleInitialState = () => {
    setStep(1);
    setUser(null);
    setInfoPlanDevice(null);
    setClient(null);
  };
  const context: IContext = useMemo(
    () => ({
      step,
      user,
      infoPlanDevice,
      client,
      infoPayment,
      setStep,
      setUser,
      setInfoPlanDevice,
      setClient,
      handleInitialState,
      setInfoPayment,
    }),
    [step, user, infoPlanDevice, client],
  );
  return (
    <CreateNewsThaniacelContext.Provider value={context}>
      {children}
    </CreateNewsThaniacelContext.Provider>
  );
};

export default CreateNewsThaniacelProvider;
